export const headers = [
  { name: 'Cod.', field: 'id', sortable: true },
  { name: 'Nome', field: 'permission.name', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
